/**
 * ETP Grid Menu – tab switching via CSS class toggling.
 *
 * Clicking a tab button:
 *   1. Removes .is-active from all tabs + panels, sets aria-selected=false + hidden
 *   2. Adds .is-active to the clicked tab + matching panel, sets aria-selected=true
 */

export function initGridMenu(scope) {
  const roots = (scope || document).querySelectorAll(
    '.etp-grid-menu:not([data-etp-grid-menu-ready])'
  );

  roots.forEach((el) => {
    el.dataset.etpGridMenuReady = 'true';

    const tabs   = el.querySelectorAll('.etp-grid-menu__tab');
    const panels = el.querySelectorAll('.etp-grid-menu__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.tab;

        tabs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('hidden', '');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const panel = el.querySelector(`#${targetId}`);
        if (panel) {
          panel.classList.add('is-active');
          panel.removeAttribute('hidden');
        }
      });
    });
  });
}
